import {Injectable} from '@angular/core';
import {Subject} from 'rxjs/Subject';
import {Observable} from 'rxjs/Observable';
import'rxjs/add/observable/from';
export class NgPureDataTableEventService {

  listeners: any;
  eventsSubject: any;
  events;
constructor() {
    this.listeners = {};
    this.eventsSubject = new Subject();

    this.events = Observable.from(this.eventsSubject);

    this.events.subscribe(
      ({name, args}) => {
        if (this.listeners[name]) {
          for (const listener of this.listeners[name]) {
            listener(...args);
          }
        }
      });
  }
/**
 * @param {?} name
 * @param {?} listener
 * @return {?}
 */
on(name, listener) {
    if (!this.listeners[name]) {
      this.listeners[name] = [];
      this.listeners[name].push(listener);
    }
    if (this.listeners[name]) {
      this.listeners[name][0] = listener;
    }
  }
/**
 * @param {?} name
 * @param {...?} args
 * @return {?}
 */
broadcast(name, ...args) {
    // console.log('name=', name);
    this.eventsSubject.next({
      name,
      args
    });
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function NgPureDataTableEventService_tsickle_Closure_declarations() {
/** @type {?} */
NgPureDataTableEventService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
NgPureDataTableEventService.ctorParameters;
/** @type {?} */
NgPureDataTableEventService.prototype.listeners;
/** @type {?} */
NgPureDataTableEventService.prototype.eventsSubject;
/** @type {?} */
NgPureDataTableEventService.prototype.events;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
